import { FeathersModel } from '../../../models/feathersModel'

export class UserManagementList_User extends FeathersModel {
  static serviceName = 'features/user-management/list'

  firstName: string
  lastName: string
  email: string
  workgroupId: number
  workgroupName: string
  locationNames: string[]
  roles: number[] // roleIds
}
